import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import utils from './utils/util'
import * as filters from './filters'
import * as directives from './directives'
import Service from './common/axios-config'
import ElementUI from 'element-ui'
import './assets/css/base.css'
import 'element-ui/lib/theme-chalk/display.css';
// import './assets/css/theme/index.css'
import md5 from 'js-md5';
import './icons'
import $ from 'jquery'
import MessageBox from './components/messageBox/index.js';
import wkCustom from "./components/wkCustom/index.js";
import './assets/js/iconfont.js'; // 引入阿里图标
import "babel-polyfill"; //#处理低版本兼容
import apis from "@/common/api-config";
import preventReClick from './utils/util'
import './element-variables.scss'


Vue.use(preventReClick);
Vue.use(ElementUI);
Vue.use(MessageBox); //封装的玩咖自用弹框组件
Vue.use(wkCustom); //封装的玩咖自用组件
// 全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 全局指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})
// 全局工具
Vue.prototype.$ = $
Vue.prototype.$md5 = md5;
window.$store = store
window.$msgBox = Vue.prototype.$msgBox
window.$utils = Vue.prototype.$utils = utils
window.$http = Vue.prototype.$http = Service
window.$apis = Vue.prototype.$apis = apis
window.configBaseURL = Vue.prototype.configBaseURL = process.env.VUE_APP_API
window.configBaseIMG = Vue.prototype.configBaseIMG = process.env.VUE_APP_IMG
window.configBaseSALT = Vue.prototype.configBaseSALT = process.env.VUE_APP_SALT

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
      document.dispatchEvent(new Event('render-event'))
  },
}).$mount('#app')